/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreImagesRequest } from '../../models/store-images-request';
import { UpsertStoreImagesResponse } from '../../models/upsert-store-images-response';

export interface StoreImagesPut$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
      body: StoreImagesRequest
}

export function storeImagesPut(http: HttpClient, rootUrl: string, params: StoreImagesPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpsertStoreImagesResponse>> {
  const rb = new RequestBuilder(rootUrl, storeImagesPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpsertStoreImagesResponse>;
    })
  );
}

storeImagesPut.PATH = '/stores/{storeId}/images';
